import type yup from '@/infra/YupDecorator';
import type { franchiseFormSchema } from './constants';
import type { ILocation } from '@/Interfaces/Data';

export type FareType = 'City' | 'Place';

export enum FareTabItems {
  MAP = 'map',
  NEIGHBORHOOD = 'neighborhood',
}

export const FareTabItemsLabel: Record<FareTabItems, string> = {
  [FareTabItems.MAP]: 'Localização',
  [FareTabItems.NEIGHBORHOOD]: 'Bairros',
};

export enum FARE_OF_TYPE {
  KM = 'km',
  NEIGHBORHOOD = 'neighborhood',
}

export const FARE_OF_TYPE_LABEL: Record<FARE_OF_TYPE, string> = {
  [FARE_OF_TYPE.KM]: 'Por Km',
  [FARE_OF_TYPE.NEIGHBORHOOD]: 'Por Bairro',
};

export type TypeFranchiseForm = yup.InferType<typeof franchiseFormSchema>;

export interface PossibleLocal {
  uf?: string;
  city?: string;
}

export interface AddressManipulationProps {
  onAddressChange?: (address: string) => void;
  addressLocation?: ILocation;
  possibleLocal?: PossibleLocal;
  address?: string;
  isLoadingAddress?: boolean;
}

interface DistrictLocation {
  latitude: number;
  longitude: number;
}

export interface District {
  _id?: string;
  name: string;
  location: DistrictLocation;
  logFee: number;
  deliveryValue: number;
  cityId: string;
  cityName: string;
  index?: number;
  generalNeighborhoodId?: string;
  generalCityId?: string;
  isActive?: boolean;
}

export interface GroupedDistricts {
  cityName: string;
  cityId: string;
  bairros: District[];
}

export interface FranchiseType {
  codigoIbge?: string;
  cityId?: string;
  cityName?: string;
  createdAt?: Date;
  establishmentName?: string;
  entregaBaseMts?: number;
  flags?: {
    key: string;
    value: boolean;
  }[];
  generalCityId?: string;
  isBillingNeighborhood?: boolean;
  isCloud?: boolean;
  localizacao?: {
    latitude: number;
    longitude: number;
  };
  maxDistanceDropsToGroup?: number;
  minDistanceCloseTo?: number;
  nome?: string;
  qtdMaxEntregaGroup?: number;
  raioMaxDistance?: number;
  requiredFormaPagamentoToConfirmReturn?: string[];
  requiredNearPlaceToConfirm?: boolean;
  requiredReturnToConfirmPayMethods?: string[];
  taxaEntregaBase?: number;
  taxaEntregaKmAdicional?: number;
  uf?: string;
  updatedAt?: Date;
  valorEntregaBase?: number;
  valorKmAdicional?: number;
  _id: string;
  fareOfType?: FARE_OF_TYPE;
  neighborhoods?: {
    _id: string;
    cityName: string;
    nome: string;
    location: {
      latitude: number;
      longitude: number;
    };
    logFee: number;
    deliveryValue: number;
    cityId: string;
    generalNeighborhoodId: string;
    isActive?: boolean;
  }[];
}
